import {
  completeReducer,
  completeState,
  createReducer,
  onReadValue
} from 'redux-recompose';
import Immutable from 'seamless-immutable';

import { actions } from './actions';

const stateDescription = {
  description: {
    tickets: [],
    lastTicket: null,
    spreadSheetTickets: null
  }
};

export const initialState = completeState(stateDescription);

const reducerDescription = {
  primaryActions: [actions.GET_TICKETS, actions.ADD_TICKET],
  override: {
    [actions.SET_LAST_TICKET]: onReadValue(),
    [actions.ADD_TIKET_TO_SPREADSHEET]: onReadValue()
  }
};

export default createReducer(
  Immutable(initialState),
  completeReducer(reducerDescription)
);
